import TitledLabel from "./TitledLabel.js";

export default TitledLabel;
